export enum RewardsBrand {
  FoxBet = 'FOX Bet',
  PokerStars = 'PokerStars'
}
